export default function buildForm(envKey, autoInviteEnabled) {
    return {
        main: {
            downloadGoogleFont: true,
            // if a good font is desired
            googleFontUrl:
                "https://fonts.googleapis.com/css2?family=Open+Sans&display=swap",
            debug: false,
            themes: { abb: "cx-theme-abb" },
            theme: "abb",
            lang: "en",
            preload: ["webchat"],
            i18n: {
                en: {
                    webchat: {
                        ChatButton: "Chat Now",
                        Errors: {
                            Generic:
                                "This chat was disconnected due to inactivity. Please try again.",
                        },
                    },
                },
            },
            customStylesheetID: "chatWidget",
            plugins: ["cx-webchat", "cx-webchat-service"],
        },
        webchat: {
            transport: {
                type: "purecloud-v2-sockets",
                dataURL: "https://api.usw2.pure.cloud",
                deploymentKey: envKey,
                orgGuid: "c2dc7adb-725e-4e03-987d-128aad6ebc42",
            },
            apikey: "",
            userData: {},
            restoreTimeout: 300000,
            autoInvite: {
                enabled: autoInviteEnabled,
                timeToInviteSeconds: 10,
                inviteTimeoutSeconds: 30,
            },
            chatButton: {
                enabled: false,
                openDelay: 1000,
                effectDuration: 300,
                hideDuringInvite: true,
            },
            uploadsEnabled: false,
        },
        form: null,
        onReady: null,
    };
}
